import React from "react";

const ProfileTypeIconCpu = () => {
  return (
    <svg viewBox="110 222 20 20" x="0px" y="0px">
      <path
        fill="currentColor"
        d="M123.3457,229.5516l-2.6137-2.0521l-0.1064-0.0728c-0.3808-0.2247-0.871-0.2251-1.2516,0.0004
                l-2.7198,2.1247c-0.3546,0.2427-0.5679,0.6479-0.5748,1.1008c-0.0072,0.4647,0.2038,0.8864,0.5671,1.1394l2.625,2.0028
                l0.0703,0.0489c0.1983,0.1255,0.426,0.192,0.6583,0.192c0.2324,0,0.4603-0.0665,0.6587-0.1922l2.6948-2.0515
                c0.3634-0.253,0.5744-0.6747,0.5671-1.1396C123.9137,230.1995,123.7004,229.7943,123.3457,229.5516z M120,231.8896l-1.6-1.221
                L120,229.4123l1.6001,1.2563L120,231.8896z M129.8578,230.5452c-0.0115-0.7417-0.3581-1.3943-0.9305-1.7592l-7.9542-5.9714
                l-0.0897-0.0598c-0.5404-0.3193-1.2264-0.3193-1.7668,0l-0.0465,0.0275l-7.9973,6.0037c-0.5724,0.3648-0.9191,1.0175-0.9306,1.7592
                c-0.0015,0.0975-0.0003,3.1263-0.0003,3.1263c0,0.5404,0.438,0.9783,0.9783,0.9783c0.5403,0,0.9783-0.4379,0.9783-0.9783v-0.5041
                l0.8077,0.6192v2.3822c0,0.5404,0.438,0.9783,0.9783,0.9783s0.9783-0.4379,0.9783-0.9783v-0.8822l1.0033,0.7692v2.6003
                c0,0.5403,0.438,0.9783,0.9783,0.9783c0.5403,0,0.9783-0.4379,0.9783-0.9783v-1.1003l1.1742,0.9002l0.0248,0.0174v2.0328
                c0,0.5404,0.438,0.9783,0.9783,0.9783c0.5403,0,0.9783-0.4379,0.9783-0.9783v-2.0359l1.199-0.9185v1.1043
                c0,0.5403,0.438,0.9783,0.9783,0.9783c0.5403,0,0.9783-0.4379,0.9783-0.9783v-2.6032l1.0033-0.7686v0.8844
                c0,0.5404,0.438,0.9783,0.9783,0.9783s0.9783-0.4379,0.9783-0.9783v-2.3833l0.8077-0.6187v0.5047
                c0,0.5404,0.438,0.9783,0.9783,0.9783c0.5403,0,0.9783-0.4379,0.9783-0.9783C129.8581,233.6715,129.8593,230.6427,129.8578,230.5452
                z M120,236.7598l-7.8022-5.9817l-0.0621-0.0424c-0.0502-0.0571-0.0501-0.2505-0.0131-0.2985l0.0463-0.0275L120,224.5308
                l7.7879,5.8466l0.076,0.0493c0.0503,0.0585,0.0505,0.2518,0.0097,0.3013L120,236.7598z"
      />
    </svg>
  );
};

export default ProfileTypeIconCpu;
